// extracted by mini-css-extract-plugin
export default {"topic":"summary_topic__eKYxA","trending_negative":"summary_trending_negative__Y9V1P","trending_positive":"summary_trending_positive__OTSw-"};